var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3557 1.78571C29.4672 -0.595233 34.5328 -0.595239 38.6443 1.78571L57.3557 12.6214C61.467 15.0023 64 19.4025 64 24.1644V45.8357C64 50.5975 61.467 54.9976 57.3557 57.3788L38.6443 68.2145C34.5328 70.5951 29.4672 70.5951 25.3557 68.2145L6.6443 57.3788C2.53279 54.9976 0 50.5975 0 45.8357V24.1644C0 19.4025 2.53279 15.0023 6.6443 12.6214L25.3557 1.78571Z",
    fill: "#FFB43A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 37.4L44 31.2495C43.6382 30.9608 43.1988 30.8032 42.7465 30.8H27.2535C26.8012 30.8032 26.3618 30.9608 26 31.2495L35 37.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3707 38.6941L35.2541 38.7509H35.1992C35.1361 38.7802 35.0691 38.7993 35.0004 38.8078V38.8078C34.9435 38.8152 34.8859 38.8152 34.829 38.8078H34.7741L34.6575 38.7509L25.469 32.6001C25.4251 32.7717 25.402 32.9482 25.4004 33.1257V43.0693C25.4004 43.6344 25.6171 44.1764 26.0029 44.576C26.3887 44.9756 26.9119 45.2001 27.4575 45.2001H42.5432C43.0888 45.2001 43.6121 44.9756 43.9979 44.576C44.3837 44.1764 44.6004 43.6344 44.6004 43.0693V33.1257C44.5988 32.9482 44.5757 32.7717 44.5318 32.6001L35.3707 38.6941Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.25L43.25 26.5619C42.7977 26.201 42.2485 26.004 41.6831 26H22.3169C21.7515 26.004 21.2023 26.201 20.75 26.5619L32 34.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4629 35.8675L32.3171 35.9386H32.2486C32.1696 35.9751 32.0858 35.999 32 36.0096V36.0096C31.9289 36.0189 31.8569 36.0189 31.7857 36.0096H31.7171L31.5714 35.9386L20.0857 28.25C20.0308 28.4644 20.002 28.6852 20 28.907V41.3365C20 42.0429 20.2709 42.7204 20.7532 43.2199C21.2354 43.7194 21.8894 44 22.5714 44H41.4286C42.1106 44 42.7646 43.7194 43.2468 43.2199C43.7291 42.7204 44 42.0429 44 41.3365V28.907C43.998 28.6852 43.9692 28.4644 43.9143 28.25L32.4629 35.8675Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_9",
    x: 9,
    y: 12,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e37dabf4d45f822b3fba1e3b908f135c.svg";
export { ForwardRef as ReactComponent };